import {
  Box,
  Card,
  CardContent,
  CardHeader,
  List,
  MenuItem,
  Switch,
  Typography,
} from "@mui/material";
import React from "react";

const UserConfig = (props) => {
  const { vehicleSearchToggle, setVehicleSearchToggle } = props;
  const handleAdvanceSearchBarChange = (event) => {
    const newMode = event.target.checked;
    setVehicleSearchToggle(!vehicleSearchToggle);
    localStorage.setItem("vehicleSettingsMode", newMode);
  };
  return (
    <Card>
      <CardHeader
        title={
          <Typography color="text.secondary">
            Vehicle Search Bar Setting
          </Typography>
        }
      ></CardHeader>
      <CardContent>
        <List sx={{ width: "100%", bgcolor: "background.paper" }}>
          <MenuItem key="vehicle-settings">  
            <Box
              sx={{
                display: "flex",
                width: "100%",
                justifyContent: "space-between",
                alignItems: "center",
              }}
            >
              <Typography>
                Advance Search: {vehicleSearchToggle ? "ON" : "OFF"}
              </Typography>
              <Switch
                checked={vehicleSearchToggle}
                onChange={handleAdvanceSearchBarChange}
                name="vehicleSettingsMode"
                color="primary"
              />
            </Box>
          </MenuItem>
        </List>
      </CardContent>
    </Card>
  );
};

export default UserConfig;
